import { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { RESPONSE_MESSAGE } from '../../../../../../../../../utils/Constant';
import { getMedicalRecordForm, getThongTinBenhAn } from './service';
import { AppContext } from '../../../../../../../../../appContext/AppContext';
import { useHoSoBenhAnContext } from './context';
import { isDisabledTab } from './common';

type Props = {
	medicalRecordId: string;
	formName: string;
	reset?: boolean;
};

export const useDetailHoSoBenhAn = ({ medicalRecordId, formName, reset }: Props) => {
	const [data, setData] = useState<any>();
	const { setIsLoading } = useContext(AppContext);

	useEffect(() => {
		medicalRecordId && getDetail();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [reset]);

	const getDetail = async () => {
		try {
			setIsLoading(true);
			const { data: response } = await getThongTinBenhAn(medicalRecordId, formName);
			setData(response);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
			setIsLoading(false);
		}
	};

	return { data };
};

export const useMedicalRecordFormIO = ({
	medicalRecordCode,
	formCode,
}: {
	medicalRecordCode: string;
	formCode: string;
}) => {
	const { setHideAction } = useHoSoBenhAnContext();
	const [formJSON, setFormJSON] = useState<any>();

	useEffect(() => {
		getFormIO();
	}, []);

	const getFormIO = async () => {
		try {
			const data = await getMedicalRecordForm(medicalRecordCode, formCode);
			const json = JSON.parse(data?.data);
			setFormJSON(json);
			setHideAction(isDisabledTab(json?.tags));
		} catch (error) {
			console.error(error);
		}
	};

	return { formJSON };
};
